
































import { Vue, Component } from "vue-property-decorator";
import api from "@/getinfo-api";
import { UserResetPasswordConfirm as IUserResetPasswordConfirm } from "@/api/models/user-reset-password-confirm";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";

@Component({ components: {} })
export default class PasswordRecovery extends Vue {
  newPassword!: string;
  newPasswordRepeat!: string;
  token!: string;
  data() {
    return {
      newPassword: undefined,
      newPasswordRepeat: undefined,
      token: undefined
    };
  }
  setupNewPassword() {
    if (typeof this.$route.query.token === "string") {
      if (this.newPassword !== this.newPasswordRepeat) {
        this.$bvToast.toast(this.$tc(this.$translate.PasswordsDoNotMatch), {
          variant: "danger",
          title: this.$tc(this.$translate.Error)
        });
      } else {
        let params: IUserResetPasswordConfirm = {
          token: this.$route.query.token,
          password: this.newPassword
        };
        api.UsersApi.confirmPassword(params)
          .then(() => {
            this.$bvToast.toast(`${this.$tc(this.$translate.Successful)}`, {
              variant: "success",
              title: this.$tc(this.$translate.Successful)
            });
            setTimeout(() => {
              this.$router.push({ name: "login" });
            }, 4000);
          })
          .catch(
            (err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
              this.$store.dispatch("errorException", {
                vm: this,
                error: err.response
              });
            }
          );
      }
    }
  }
  mounted() {}
}
